import { render } from "./squared-image.vue?vue&type=template&id=4501f9c5&scoped=true"
import script from "./squared-image.vue?vue&type=script&lang=js"
export * from "./squared-image.vue?vue&type=script&lang=js"

import "./squared-image.vue?vue&type=style&index=0&id=4501f9c5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4501f9c5"]])

export default __exports__